import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  FaChartBar,
  FaTh,
  FaUser,
  FaSignOutAlt,
  FaBars,
  FaTimes
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { toast } from "react-toastify";
import { useAuth } from "../context/AuthContext";
import api from "../services/api";
import "./Navbar.css";

const Navbar = () => {

  useTranslation();
  const { corporator, logout } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();

  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
  };

  const handleLogout = async () => {

    try {
      await api.post("/api/corporator/logout");
    } catch (e) {}

    logout();

    toast.success("Logged out");

    navigate("/login");
  };

  return (

    <nav className="navbar">

      <div className="navbar-container">

        {/* Logo */}

        <div className="navbar-brand">

          🏛️ Corporator Portal

        </div>

        {/* Hamburger */}

        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>

        {/* Menu */}

        <div className={`navbar-menu ${menuOpen ? "active" : ""}`}>

          <Link
            to="/dashboard"
            className={isActive("/dashboard") ? "active" : ""}
            onClick={() => setMenuOpen(false)}
          >
            <FaTh />
            Dashboard
          </Link>

          <Link
            to="/analytics"
            className={isActive("/analytics") ? "active" : ""}
            onClick={() => setMenuOpen(false)}
          >
            <FaChartBar />
            Analytics
          </Link>

          <Link
            to="/profile"
            className={isActive("/profile") ? "active" : ""}
            onClick={() => setMenuOpen(false)}
          >
            <FaUser />
            Profile
          </Link>

        </div>

        {/* Right */}

        <div className="navbar-right">

          <div className="language-switch">

            <button
              onClick={() => changeLanguage("en")}
              className={i18n.language === "en" ? "active" : ""}
            >
              EN
            </button>

            <button
              onClick={() => changeLanguage("mr")}
              className={i18n.language === "mr" ? "active" : ""}
            >
              मराठी
            </button>

          </div>

          <div className="user-box">

            <div>

              <div className="user-name">

                {corporator?.name || "Corporator"}

              </div>

              <div className="user-ward">

                Ward {corporator?.ward || "-"}

              </div>

            </div>

          </div>

          <button
            className="logout-btn"
            onClick={handleLogout}
          >
            <FaSignOutAlt />
          </button>

        </div>

      </div>

    </nav>

  );

};

export default Navbar;